import { combineReducers } from "@reduxjs/toolkit";
import issueReducer from "./issues";
import userReducer from "./users";
import clientReducer from "./clients";
import dashboardReducer from "./dashboard";
import bprmFormReducer from "./bprmForm";
import wfAppReducer from "./wfApp";
import documentReducer from "./document";

export default combineReducers({
    issues: issueReducer,
    users: userReducer,
    clients: clientReducer,
    dashboard: dashboardReducer,
    bprmForm: bprmFormReducer,
    wfApp: wfAppReducer,
    documents: documentReducer,
});